module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("96lLg"))).then(() => module.bundle.root('d181N'));